import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { EnvType } from "./constants";
import BillboardItem from './billboard-item';
import ThumbnailItem from './thumbnail-item';
import VideoPlayer from './video-player';
import thin_left_chevron from '../../assets/svod/buttons/thin-left-chevron.png';
import thin_right_chevron from '../../assets/svod/buttons/thin-right-chevron.png';
import { formatDuration } from '../../functions/time';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCircleInfo, faPlay } from '@fortawesome/free-solid-svg-icons';
import {
	toggleVolume,
	setPreviousSelectedAsset,
	setSelectedAsset,
	setSelectedAssetRow
} from '../../redux/actions/SVOD';
import { returnBrandingInformation, isNumber } from '../../functions/utils';

class BillboardRow extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			scrollPosition: 0,
			indicatorIdx: 0,
			currentBillboardIndex: 0,
			billboardVideos: [],
			currentBillboard: null,
			isBillboardVisible: true,

			billboardImageActive: true, // displays the billboard image for apple's dynamic billboard using css
			billboardVideoActive: false, // displays the billboard video for apple's dynamic billboard using css
			enabledBillboardVideo: true, // displays the billboard video for apple's dynamic billboard once the video is ready to play
		};

		this.billboardRowTimeout = {}; // creates the timeout intervals for each billboard image in apple's dynamic billboard
		this.dynamicBillboardThumbnail;

		this.handleVideoEnded = this.handleVideoEnded.bind(this);
		this.handleVideoReady = this.handleVideoReady.bind(this);
		this.handleEnterBillboardItem = this.handleEnterBillboardItem.bind(this);

		this.getBillboardInfo = this.getBillboardInfo.bind(this);
		this.getBillboardVideoIds = this.getBillboardVideoIds.bind(this);
		this.slideLeft = this.slideLeft.bind(this);
		this.slideRight = this.slideRight.bind(this);
		this.onScrollEvent = this.onScrollEvent.bind(this);
		this.clearBillboardTimers = this.clearBillboardTimers.bind(this);
		this.setBillboardTimer = this.setBillboardTimer.bind(this);
		this.selectAsset = this.selectAsset.bind(this);
		this.updateBillboardAsset = this.updateBillboardAsset.bind(this);
		this.updatedBillboard = this.updatedBillboard.bind(this);
	}

	componentDidMount() {
		const { toggleVolume, isDynamicBillboard, environment } = this.props;
		if (isDynamicBillboard) {
			toggleVolume(true); // toggles volume for billboard video for apple's dynamic billboard
		}

		if (environment === EnvType.PEACOCK) {
			const billboardImage = document.getElementById("splash-background-img");
			if (billboardImage) {
				billboardImage.classList.add("image-loaded");
			}
		}
	}

	onScrollEvent() {
		const { isBillboardVisible, currentBillboardIndex } = this.state;
		const parent = document.getElementById("svod-page");
		const billboardImage = document.getElementById("splash-background-img");
		let heightToDimFrom = 200;
		const winScroll = parent.scrollTop;

		if (billboardImage) {
			if (winScroll > heightToDimFrom) {
				if (isBillboardVisible) {
					billboardImage.classList.add("dim");
					this.clearBillboardTimers();
					this.setState({ isBillboardVisible: false });
				}
			} else if (!isBillboardVisible) {
				billboardImage.classList.remove("dim");
				this.billboardRowTimeout[currentBillboardIndex] = this.setBillboardTimer();
				this.setState({ isBillboardVisible: true });
			}
		}
	}

	clearBillboardTimers() {
		const { billboardVideos } = this.state;
		for (let index = 0; index < billboardVideos.length; index++) {
			clearTimeout(this.billboardRowTimeout[index]);
			this.billboardRowTimeout[index] = null;
		}
	}

	updatedBillboard(index) {
		const { billboardVideos } = this.state;
		const billboardImage = document.getElementById("splash-background-img");
		const nextIndex = (index === billboardVideos.length - 1 || index < 0) ? 0 : index + 1;
		const newBillboard = billboardVideos[nextIndex];
		this.setState({ currentBillboardIndex: nextIndex });
		if (billboardImage) {
			billboardImage.classList.add("image-loading");
			billboardImage.classList.remove("image-loaded");

			const img = new Image();
			img.src = newBillboard.images.background;
			this.clearBillboardTimers();

			img.onload = () => {
				setTimeout(() => {
					this.setState({
						billboardImageActive: true,
						billboardVideoActive: false,
						enabledBillboardVideo: false,
						currentBillboard: newBillboard,
					}, () => {
						billboardImage.classList.add("image-loaded");
						billboardImage.classList.remove("image-loading");
					});
				}, 300);
			};
		}
	}

	setBillboardTimer(index) {
		const { currentBillboardIndex } = this.state;
		const currentIndex = isNumber(index) ? index : currentBillboardIndex;
		return setTimeout(() => {
			this.updatedBillboard(currentIndex);
		}, 5000);
	}

	componentDidUpdate(prevProps, prevState) {
		const { videos, isDynamicBillboard, environment, beganSVODExperienceTime } = this.props;
		const { currentBillboardIndex, currentBillboard } = this.state;
		const allVideoRowLabels = Object.keys(videos);
		let billboardThumbnailsSet = this.state.billboardThumbnailsSet;

		if (!currentBillboard
			&& isDynamicBillboard
			&& (environment === EnvType.APPLETV
				|| environment === EnvType.PEACOCK)
			&& allVideoRowLabels
			&& allVideoRowLabels.length
		) {
			const billboardRowLabel = allVideoRowLabels.find((value) => value.indexOf("Billboard") >= 0);
			if (billboardRowLabel) {
				const billboard_vids = videos[billboardRowLabel];

				const videoIds = (billboard_vids !== undefined) ? Object.keys(billboard_vids) : [];
				const billboardVideos = [];
				for (let i = 0; i < videoIds.length; i++) {
					billboardVideos.push(billboard_vids[videoIds[i]]);
				}

				const updatedBillboard = billboardVideos[currentBillboardIndex];

				this.setState({ currentBillboard: updatedBillboard, billboardVideos });
				if (environment === EnvType.PEACOCK) {
					const parent = document.getElementById("svod-page");
					parent.addEventListener("scroll", this.onScrollEvent);
				}
			}
		}

		if ((!prevProps.beganSVODExperienceTime && beganSVODExperienceTime) || (beganSVODExperienceTime && environment === EnvType.PEACOCK && !this.billboardRowTimeout[currentBillboardIndex] &&
			((currentBillboard && !prevState.currentBillboard) ||
				(currentBillboard && prevState.currentBillboard && currentBillboard._id !== prevState.currentBillboard._id)))
		) {
			this.billboardRowTimeout[currentBillboardIndex] = this.setBillboardTimer();
		}

		if (!environment === EnvType.PEACOCK) {
			const billboardThumbnails = document.getElementsByClassName(`dynamic-thumbnail`);
			if (billboardThumbnails.length && !billboardThumbnailsSet) {
				billboardThumbnailsSet = true;
				this.setState({ billboardThumbnailsSet }, () => {
					for (let index = 0; index < billboardThumbnails.length; index++) {
						let thumbnail = billboardThumbnails[index];

						thumbnail.addEventListener('mouseover', (event) => {
							this.billboardRowTimeout[index] = setTimeout(() => {
								this.handleEnterBillboardItem();
							}, 1000);
						});

						thumbnail.addEventListener('mouseout', (event) => {
							clearTimeout(this.billboardRowTimeout[index]);
						});
					}
				});
			}
		}
	}

	handleEnterBillboardItem() {
		const { billboardVideos, currentBillboardIndex } = this.state;

		const billboardThumbnails = document.getElementsByClassName("dynamic-thumbnail");
		const newBillboard = billboardVideos[currentBillboardIndex];
		const billboardImage = document.getElementById("dynamic-billboard-image");
		if (billboardImage) {
			billboardImage.classList.add("image-loading");
			billboardImage.classList.remove("image-loaded");

			const img = new Image();
			img.src = newBillboard.images.background;
			for (let index = 0; index < billboardThumbnails.length; index++) {
				clearTimeout(this.billboardRowTimeout[index]);
			}

			img.onload = () => {
				setTimeout(() => {
					this.setState({
						currentBillboard: newBillboard,
						billboardImageActive: true,
						billboardVideoActive: false,
						enabledBillboardVideo: false
					}, () => {
						billboardImage.classList.add("image-loaded");
						billboardImage.classList.remove("image-loading");

						setTimeout(() => {
							this.setState({ enabledBillboardVideo: true });
						}, 500);
					});
				}, 300);
			};
		}
	}

	handleVideoReady(videoObj, postMessageData) {
		this.setState({ billboardImageActive: false, billboardVideoActive: true });
	}

	handleVideoEnded() {
		this.setState({ billboardImageActive: true, billboardVideoActive: false });
	}

	handleBillboardScroll(scrollPosition) {
		let vidItems = document.getElementsByClassName(`videoItem-billboard`);
		document.documentElement.style.setProperty('--lolomo-scroll', `${scrollPosition}px`);
		for (let i = 0; i < vidItems.length; i++) {
			vidItems[i].style.transform = `translateX(${scrollPosition}px`;
		}
	}

	triggerReport(currentBillboard, billboardRowLabel, clickType) {
		const row_name = billboardRowLabel.split("_")[0];
		const row_id = billboardRowLabel.split("_")[1];
		this.props.setSelectedAsset(currentBillboard);
		this.props.setSelectedAssetRow(row_name);

		if ((this.props.environment === EnvType.PEACOCK
			|| this.props.environment === EnvType.APPLETV)
			&& clickType === "showpage"
		) {
			this.props.eventHandler({
				data: {
					row_name,
					row_id,
					event_type: "billboard_click",
					asset_name: currentBillboard.name,
					asset_id: currentBillboard._id,
					page_location: "home_page",
					time: Date.now()
				}
			});
		} else {
			this.props.eventHandler({
				data: {
					row_name,
					row_id,
					event_type: "button_click",
					type: "watch_episode_click",
					asset_name: currentBillboard.name,
					asset_id: currentBillboard._id,
					page_location: "home_page",
					time: Date.now()
				}
			});
		}
	}

	getBillboardInfo() {
		let billboardRow = Object.keys(this.props.videos).filter(function (value) { return value.indexOf("Billboard") >= 0; });
		let billboardRowString = billboardRow[0];
		let rowTitle = (billboardRowString.split("_")[0]);
		let rowId = (billboardRowString.split("_")[1]);

		return { rowTitle, rowId };
	}

	getBillboardVideoIds() {
		let allVideoRows = Object.keys(this.props.videos);
		let billboardRow = allVideoRows.filter(function (value) { return value.indexOf("Billboard") >= 0; });
		let billboardRowLabel = billboardRow[0];
		let billboard_vids = this.props.videos[billboardRowLabel];
		let videoIds = Object.keys(billboard_vids);
		return videoIds;
	}

	slideLeft() {
		const { environment } = this.props;
		const { scrollPosition, indicatorIdx } = this.state;

		let scrollAmount = document.body.clientWidth;

		switch (environment) {
			case EnvType.PEACOCK: scrollAmount = scrollAmount / 2;
		}

		let newPos = scrollPosition + scrollAmount;
		let newIndex = indicatorIdx;
		if (newPos >= 1) newPos = 0;
		if (indicatorIdx > 0) newIndex -= 1;

		let videoIds = this.getBillboardVideoIds();
		if (newIndex < 0) newIndex = 0;
		let billboard_in_view = videoIds[newIndex];

		this.props.eventHandler({
			data: {
				event_type: "button_click",
				type: "scroll_click",
				row_name: this.getBillboardInfo().rowTitle,
				row_id: this.getBillboardInfo().rowId,
				direction: 'left',
				page_location: "home_page",
				billboard_in_view: billboard_in_view,
				time: Date.now()
			}
		});

		this.handleBillboardScroll(newPos);
		this.setState({ scrollPosition: newPos, indicatorIdx: newIndex });
	}

	slideRight() {
		const { environment } = this.props;
		const { indicatorIdx, scrollPosition } = this.state;

		const lolomoWidth = document.getElementById('billboard-slide').scrollWidth;
		let scrollAmount = document.body.clientWidth;

		switch (environment) {
			case EnvType.PEACOCK: scrollAmount = scrollAmount / 2;
		}

		let newPos = scrollPosition - scrollAmount;
		let newIndex = indicatorIdx + 1;
		const scrollPositionCheck = -lolomoWidth + scrollAmount;
		if (scrollPositionCheck == 0) {
			newPos = 0;
			newIndex = 0;
		}

		let videoIds = this.getBillboardVideoIds();
		if (newIndex >= videoIds.length) newIndex = 0;
		let billboard_in_view = videoIds[newIndex];

		this.props.eventHandler({
			data: {
				event_type: "button_click",
				type: "scroll_click",
				row_name: this.getBillboardInfo().rowTitle,
				row_id: this.getBillboardInfo().rowId,
				direction: 'right',
				page_location: "home_page",
				billboard_in_view: billboard_in_view,
				time: Date.now()
			}
		});

		this.handleBillboardScroll(newPos);

		this.setState({
			scrollPosition: newPos,
			indicatorIdx: newIndex
		}, () => {
		});
	}

	selectAsset(asset) {
		const {
			videos,
		} = this.props;
		let allVideoRows = Object.keys(videos);
		let billboardRow = allVideoRows.filter(function (value) { return value.indexOf("Billboard") >= 0; });
		let billboardRowLabel = billboardRow[0];
		this.props.setSelectedAsset(asset);
		this.props.setSelectedAssetRow(billboardRowLabel);
	}

	updateBillboardAsset(asset, index) {
		this.clearBillboardTimers();
		this.updatedBillboard(index - 1);
		this.billboardRowTimeout[index] = this.setBillboardTimer(index);
	}

	render() {
		const {
			environment,
			videos,
			isDynamicBillboard,
			rowInformation,
			targetAssets,
		} = this.props;

		const {
			currentBillboardIndex,
			billboardImageActive,
			enabledBillboardVideo,
			currentBillboard,
			indicatorIdx,
		} = this.state;

		let allVideoRows = Object.keys(videos);

		// for testing billboard in amazon -> so there are multiple vids
		// let billboardRow = allVideoRows.filter(function (value) { return value.indexOf("Popular") >= 0; });

		let billboardRow = allVideoRows.filter(function (value) { return value.indexOf("Billboard") >= 0; });
		let billboardRowLabel = billboardRow[0];
		let billboard_vids = videos[billboardRowLabel];

		let videoIds = billboard_vids ? Object.keys(billboard_vids) : [];

		let billboardVideos = [];
		for (let i = 0; i < videoIds.length; i++) {
			billboardVideos.push(billboard_vids[videoIds[i]]);
		}

		let billboard_items = billboardVideos.map((billboard, idx) => {
			let activeBillboard = (!isDynamicBillboard && indicatorIdx === idx) || (isDynamicBillboard && currentBillboardIndex === idx);

			if (isDynamicBillboard) {
				return (
					<ThumbnailItem {...this.props}
						key={`billboard`}
						idx={idx}
						video={billboard}
						billboardLabel='billboard'
						page_location="home_page"
						label={billboardRowLabel}
						activeBillboard={activeBillboard}
						watchlist_video={false}
						ref={ref => (this.dynamicBillboardThumbnail = ref)}
						onMouseEnter={() => this.setState({ currentBillboardIndex: idx })}
						isDynamicBillboard={isDynamicBillboard}
						onClick={() => this.updateBillboardAsset(billboard, idx)}
					/>
				);
			}
			else {
				return (
					<BillboardItem {...this.props}
						key='billboard'
						index={idx}
						video={billboard}
						label={billboardRowLabel}
						activeBillboard={activeBillboard}
						page_location="home_page"
					/>
				);
			}
		});

		let carouselPos = (billboardVideos.map((billboard, idx) => {
			if (indicatorIdx === idx) {
				return (<li className="carousel-list-item-selected" key="carousel"></li>);
			} else {
				return (<li className="carousel-list-item" key="carousel"></li>);
			}
		}));

		let billboard = <span></span>;

		if (billboard_items.length > 0) {
			switch (environment) {
				case EnvType.NETFLIX:
					billboard = (
						<div className="billboard-row" id="billboard-slide">
							{billboard_items[0]}
						</div>
					);
					break;

				case EnvType.AMAZON:
					if (billboard_items.length > 1) {
						billboard = (
							<div className="billboard-row" id="billboard-slide">
								<button className="scrollLeft" id={`slide-left-billboard`} onClick={this.slideLeft} > <i className="fas fa-chevron-left"></i></button>
								<button className="scrollRight" id={`slide-right-billboard`} onClick={this.slideRight} ><i className="fas fa-chevron-right"></i></button>
								{billboard_items}
								<ul className="carousel-list">
									{carouselPos}
								</ul>
							</div>
						);
					} else {
						billboard = (
							<div className="billboard-row" id="billboard-slide">
								{billboard_items}
							</div>
						);
					}
					break;

				case EnvType.PEACOCK:
					if (isDynamicBillboard) {
						billboardRowLabel = 'Featured';
						const billboardImage = currentBillboard ? currentBillboard.images.background : null;
						const billboardTitleImage = currentBillboard ? currentBillboard.images.title : '';
						const billboardDescription = currentBillboard ? currentBillboard.content.logline : '';
						const genre = currentBillboard && currentBillboard.content && currentBillboard.content.genres ? currentBillboard.content.genres.join(" · ") : '';
						const seasonCount = currentBillboard && currentBillboard.season_count ? currentBillboard.season_count : '';
						const brandingInfo = returnBrandingInformation(currentBillboard || {}, rowInformation);
						const metadata = seasonCount ? genre + ` · ${seasonCount} Seasons` : genre;

						const isTargetAsset = !!(targetAssets && currentBillboard && targetAssets.find((asset) => (asset.id || asset._id) === (currentBillboard.id || currentBillboard._id)));
						billboard = currentBillboard ?
							<div onClick={() => this.selectAsset(currentBillboard)}>
								<div className="rpo-vid-div" id="hero">
									<div className="splash-img-container">
										<img className="splash-img" id="splash-background-img" src={billboardImage} alt={billboardImage} />
									</div>
								</div>
								<div className="billboard-content">
									<div className='billboard-title-image-container'>
										<img className="billboard-title-image" src={billboardTitleImage} />
									</div>
									<div className="asset-description">
										<span className="metadata">
											{metadata}
										</span>
										<p className="summary">{billboardDescription}</p>
										{isTargetAsset && brandingInfo ?
											<div className="home-page-branding">
												<p className="m-0 mr-5">Presented by</p>
												<img src={brandingInfo.branding} />
											</div> : ""
										}
									</div>
									<div className="billboard-buttons-container">
										<div className="billboard-spotlight-buttons">
											<Link to="/study/showpage" onClick={() => this.triggerReport(currentBillboard, billboardRow[0], 'showpage')}>
												<button className="homepage-button">
													<FontAwesomeIcon icon={faCircleInfo} className="mr-10" />
													MORE EPISODES
												</button>
											</Link>
											<Link to="/study/watch" onClick={() => this.triggerReport(currentBillboard, billboardRow[0])}>
												<button className="homepage-button play">
													<FontAwesomeIcon icon={faPlay} className="mr-10" />
													WATCH LATEST EPISODE
												</button>
											</Link>
										</div>
										<div className="billboard-nav-bar">
											{billboard_items}
										</div>
									</div>
								</div>
							</div>
							: '';
					}
					else if (billboard_items.length > 1) {
						billboard = (
							<div className="billboard-row" id="billboard-slide">
								<button className="scrollButton scrollLeft" id={`slide-left-billboard`} onClick={this.slideLeft} > <i className="fas fa-chevron-left"></i></button>
								<button className="scrollButton scrollRight" id={`slide-right-billboard`} onClick={this.slideRight} ><i className="fas fa-chevron-right"></i></button>
								{billboard_items}
								<ul className="carousel-list">
									{carouselPos}
								</ul>
							</div>
						);
					} else {
						billboard = (
							<div className="billboard-row" id="billboard-slide">
								{billboard_items}
							</div>
						);
					}
					break;

				case EnvType.APPLETV:
					if (isDynamicBillboard) {
						billboardRowLabel = 'Featured';
						const billboardImage = currentBillboard ? currentBillboard.images.background : null;
						const billboardTitleImage = currentBillboard ? currentBillboard.images.title : '';
						const billboardDescription = currentBillboard ? currentBillboard.content.logline : '';
						const genre = currentBillboard && currentBillboard.content && currentBillboard.content.genres ? currentBillboard.content.genres.toLocaleString() : '';
						const mpaa = currentBillboard && currentBillboard.content && currentBillboard.content.mpaa ? currentBillboard.content.mpaa.label : '';
						const duration = currentBillboard && currentBillboard.video && currentBillboard.video.duration ? formatDuration(currentBillboard.video.duration, null, null, false, true) : '';

						billboard = currentBillboard ?
							<div className='dynamic-billboard-wrapper'>
								{enabledBillboardVideo ?
									<VideoPlayer {...this.props}
										id="rpo-vid"
										className='billboard-video'
										location="BILLBOARDVIDEO"
										videoVolumeReady={this.handleVideoReady}
										videoEnded={this.handleVideoEnded}
										onRef={ref => this.videoElement = ref}
										video={currentBillboard}
										watchpage={false}
									/>
									: ''
								}
								<img id='dynamic-billboard-image' className={`current-billboard-image width-100p ${billboardImageActive ? '' : 'opacity-0p'}`} src={billboardImage} />

								<div className='dynamic-billboard-title'>
									<img src={billboardTitleImage} />
									<p className='billboard-meta-data m-0'>{genre} <FontAwesomeIcon icon={faCircle} /> {duration} <span>{mpaa}</span></p>
									<p className='billboard-description m-0'>{billboardDescription}</p>
								</div>

								<div className="slider position-relative"
									id="billboard-slide"
									style={{ top: '-276px' }}>
									<p className="lolomo-title">{billboardRowLabel}</p>
									{this.state.scrollPosition != 0 && (
										<button className="scrollButton scrollLeft" id={`slide-left-billboard`} onClick={this.slideLeft} ><img src={thin_left_chevron} /></button>
									)}
									<button className="scrollButton scrollRight" id={`slide-right-billboard`} onClick={this.slideRight} ><img src={thin_right_chevron} /></button>
									<div id={`billboard-slide-list`} className={`category-list`}>
										{billboard_items}
									</div>
								</div>
							</div>
							: '';
					}
					else if (billboard_items.length > 1) {
						billboard = (
							<div className="billboard-row" id="billboard-slide">
								{this.state.scrollPosition != 0 && (
									<button className="scrollButton scrollLeft" id={`slide-left-billboard`} onClick={this.slideLeft} ><img src={thin_left_chevron} /></button>
								)}
								<button className="scrollButton scrollRight" id={`slide-right-billboard`} onClick={this.slideRight} ><img src={thin_right_chevron} /></button>
								{billboard_items}
							</div>
						);
					}
					else {
						billboard = (
							<div className="billboard-row" id="billboard-slide">
								{billboard_items}
							</div>
						);
					}
					break;
			}
		}

		return (
			<span className="billboard-container">
				{billboard}
			</span>
		);
	}
}

const mapStateToProps = (state) => ({
	dropdown: state.SVOD.dropdown,
	volume: state.SVOD.volume,
	profilePictureNumber: state.SVOD.profilePictureNumber,
	environment: state.SVOD.environment,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
	isSurveyActive: state.SVOD.isSurveyActive,
	rowInformation: state.targetProcess.fetchedGroup.svod_env.rows,
});

const mapDispatchToProps = (dispatch) => ({
	toggleVolume: (volume) => dispatch(toggleVolume(volume)),
	setPreviousSelectedAsset: (asset) => dispatch(setPreviousSelectedAsset(asset)),
	setSelectedAsset: (asset) => dispatch(setSelectedAsset(asset)),
	setSelectedAssetRow: (label) => dispatch(setSelectedAssetRow(label)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BillboardRow);



// WEBPACK FOOTER //
// ./src/components/svod/billboard-row.jsx